const colors = {
  darkGrey: "#C1C1C1",
  grey: "#DADADA",
  red: "#B7302C",
  white: "#FFFFFF",
}

export default colors;
